import { z } from "zod";

export const editEventMemberSchema = z.object({
  motifAbsence: z.string().min(1, "Le motif d'absence est requis"),
});
